export enum MentionContentCustomizationEnum {
    headlineOnly = 'headlineOnly',
    lead = 'lead',
    fullText = 'fullText',
    summary = 'summary'
}
